module.exports = __webpack_public_path__ + "media/images/about/b1-bcf64bc121b10dd95079fb3f8a4c2a87.png";